import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonBackButton,
  IonTitle,
} from '@ionic/react';
import cx from 'classnames';
import { cart, personCircleOutline, arrowBack } from 'ionicons/icons';

import { mdAccountIcon, mdCartIcon } from '@/assets/common/icons';
import { Badge } from '@/components/Common';
import { QuantumTags } from '@/config/quantum';
import { useCartCount } from '@/hooks/useCartCount';
import { useECommercePaths } from '@/hooks/useECommercePaths';
import { usePlatform } from '@/hooks/usePlatform';
import { QMEvent, useQuantumMetric } from '@/hooks/useQuantumMetric';
import { bridge } from '@/lib/bridge';
import { useAuthState } from '@/redux/hooks/auth';

import * as styles from './AppHeader.css';

interface AppHeaderProps {
  title?: string;
}

export const AppHeader = ({ title }: AppHeaderProps) => {
  const { sendQMEvent } = useQuantumMetric();
  const { isAndroid, isIOS } = usePlatform();
  const { isAuthenticated } = useAuthState();
  const { cartPath } = useECommercePaths();
  const cartCount = useCartCount();

  const handleAccountButtonClick = () => {
    sendQMEvent(QMEvent.AccountTap);
    bridge.launchAccountPage();
  };
  const handleECommButtonClick = () => {
    sendQMEvent(QMEvent.CartTap);
    bridge.launchEComm(cartPath);
  };

  return (
    <IonHeader collapse="fade">
      <IonToolbar>
        <IonButtons slot="start">
          <IonBackButton icon={arrowBack} text="" color="primary" />
        </IonButtons>

        {!!title && <IonTitle>{title}</IonTitle>}

        <IonButtons slot="end">
          <IonButton onClick={handleAccountButtonClick} data-tag-id={QuantumTags.AccountButton}>
            <IonIcon
              slot="icon-only"
              md={mdAccountIcon}
              ios={personCircleOutline}
              color="primary"
            />
          </IonButton>

          {isAuthenticated && (
            <IonButton
              className={styles.button}
              onClick={handleECommButtonClick}
              data-tag-id={QuantumTags.CartButton}
            >
              {!!cartCount && (
                <Badge
                  count={cartCount}
                  className={cx({
                    [styles.badge['ios']]: isIOS,
                    [styles.badge['android']]: isAndroid,
                  })}
                />
              )}
              <IonIcon slot="icon-only" md={mdCartIcon} ios={cart} color="primary" />
            </IonButton>
          )}
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  );
};
